import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Languages from '../components/Languages';
import MagicShortcuts from '../components/MagicShortcuts';
import HowItWorks from '../components/HowItWorks';
import PowerFeatures from '../components/PowerFeatures';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <TrustBar />
      <Features />
      <Languages />
      <MagicShortcuts />
      <HowItWorks />
      <PowerFeatures />
      <Pricing />
      <Footer />
    </div>
  );
};

export default Home;
